// extracted by mini-css-extract-plugin
export var searchHeader = "_8h-0";
export var searchHeaderDark = "_8h-1";